import { render } from "./PatchNotesDialog.vue?vue&type=template&id=38644d51"
import script from "./PatchNotesDialog.vue?vue&type=script&lang=js"
export * from "./PatchNotesDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Downloads\\21TCG\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__